const fetchError = (error) => {
  // eslint-disable-next-line no-console
  console.log('error', error)
}

const fetchData = async (endpoint, callback = null) => {
  return fetch(endpoint)
    .then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json()
      } else {
        callback ? callback() : fetchError(response.statusText)
        throw Error(response.statusText)
      }
    })
    .then((jsonResponse) => {
      return jsonResponse
    })
    .catch((error) => {
      callback ? callback(error) : fetchError(error)
    })
}

const postData = async (endpoint, body, type = 'json', callback = null) => {
  return fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: type === 'json' ? JSON.stringify(body) : body
  })
    .then((response) => {
      if (response.status >= 200 && response.status <= 299) {
        return response.json()
      } else {
        callback ? callback(response) : fetchError(response.statusText)
      }
    })
    .then((jsonResponse) => {
      return jsonResponse
    })
    .catch((error) => {
      fetchError(error)
    })
}

export { fetchData, postData }
